import React, { useEffect, useState } from 'react';
import { getAppEnv } from '../../../../config/env';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const CabInfo = ({ commonInfo, style }) => {
  const initializeCollapseStateMap = initVal => {
    const stateMap = new Map<number, boolean>();
    commonInfo.content.forEach((_, idx) => {
      stateMap.set(idx, initVal);
    });
    return stateMap;
  };
  const [cabInfoState, setCabInfoState] = useState<Map<number, boolean>>(
    initializeCollapseStateMap(true)
  );

  useEffect(() => {
    setCabInfoState(initializeCollapseStateMap(false));
  }, []);

  const updateCollapseState = (idx, val) => {
    const newCabInfoState = new Map(cabInfoState);
    newCabInfoState.set(idx, val);
    setCabInfoState(newCabInfoState);
  };

  return (
    <div
      id="commonInfo"
      className="whiteBackGroundColor appendTop10"
      style={{ padding: '10px 16px 4px 16px' }}
    >
      {commonInfo.content.map(
        ({ header, para }: { header: string; para: string }, idx) => {
          return (
            <div className="appendBottom20">
              <div
                onClick={() => updateCollapseState(idx, !cabInfoState.get(idx))}
                className="makeFlex appendTop10 "
              >
                <h2 className="font14 latoBold darkGreyText appendBottom5 ">
                  {header}
                </h2>
                <div
                  style={{ marginLeft: 'auto', marginRight: '10px' }}
                  className={`vertlCenter ${style.arrow} ${
                    cabInfoState.get(idx) ? style.up : style.down
                  }`}
                ></div>
              </div>
              {cabInfoState.get(idx) ? (
                <p
                  className="font12 lineHeight16"
                  style={{ color: 'rgb(74, 74, 74)' }}
                  dangerouslySetInnerHTML={{ __html: para }}
                ></p>
              ) : null}
            </div>
          );
        }
      )}
    </div>
  );
};
